module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-xi"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chief Historical Consultant")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Gyula Sárhidai")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Further Historical Consultants")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tamás Baczoni")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Péter Bilik")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Antal Fejes")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Vladimír Francev")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Dr. Zoltán András Kovács")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Dr. Imre Domokos Nagy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Břetislav Nakládal")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Kamen Nevenkin")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Leo W.G. Niehorster")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("György Punka")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Jiří Tintěra")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Jaroslav Tvrdý")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ferenc-Antal Vajda")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Péter Zámbori")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Further Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Iván Bajtos (deceased)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Lajos Berényi")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Aldo Carrer")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Zsolt Dávid")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Henry Hoppe")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Márton László")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Gerald Mlynek")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Dr. Péter Mujzer")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-xii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Photo Credits")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Most of the photographs in this book come from the authors’ personal collections.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Other contributors:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Balázs Almási")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Péter Bilik")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Aldo Carrer")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fortepan Team (especially Miklós Tamási)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Miklós Éder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Antal Gerencsér")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Andor Gibás (deceased)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Andrew Hennessy (formerly Endre Hitesi) (deceased)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("László Hemmert")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Henry Hoppe")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("László Jávor")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("László")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Zoltán Lakos")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tony Latoche (deceased)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Dr. Péter Mujzer")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Dr. József Németh")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Kamen Nevenkin")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Attila Palotai")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("György Punka")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Gyula Sárhidai")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sándor Sarkady jr.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Andor Szeltner")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ferenc Szeverényi")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Zoltán Tálosi")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Patrik Ungár")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("László Winkler (deceased)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Károly Zajtai")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Péter Zákányi")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Lutz Zours-Konetzny")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Archives of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Haditechnica")]), _vm._v(" military periodical")]), _vm._v(" "), _c('p', {
    staticClass: "noindenth"
  }, [_vm._v("Archives of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hadtörténeti Intézet és Múzeum")]), _vm._v(" (Institute and Museum of Military History)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenth"
  }, [_vm._v("Archives of the (defunct) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kanadai Magyar Szárnyak")]), _vm._v(" (Hungarian Wings of Canada)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenth"
  }, [_vm._v("Archives of the (defunct) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Magyar Munkásmozgalmi Múzeum")]), _vm._v(" (Museum of Hungarian Workers’ Movement)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenth"
  }, [_vm._v("Archives and publications of the (defunct) ‘MKCSBK’ Hungarian Veterans (Canada) Archives and publications of the (defunct) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Vitézi Rend")]), _vm._v(" and ‘MHBK’ (Germany)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a27ef4d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 78
// module chunks = 0